import {
  DialogContent,
  Dialog,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useCreateInvitation } from "../api";
import "../i18n/config";
import { ChangeEvent, useEffect, useState } from "react";
import { Share } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

type ModalNicknameProps = {
  isOpen: boolean;
  close: () => void;
  groupId: string;
};

export const ModalNewMember = (props: ModalNicknameProps) => {
  const { isOpen, close, groupId } = props;
  const { t } = useTranslation();

  const { invitationLink, setGroupId } = useCreateInvitation();

  useEffect(() => {
    if (groupId) {
      setGroupId(groupId);
    }
  }, [groupId]);

  return (
    <Dialog
      PaperProps={{ style: { height: "335px" } }}
      open={isOpen}
      onClose={close}
    >
      <DialogTitle>
        <Typography>{t(`exported.Join a Group`)}</Typography>
      </DialogTitle>
      <DialogContent style={{ paddingTop: "4px" }}>
        <TextField
          key={0}
          fullWidth
          label={t("members.Single Use Clinic Join Link")}
          value={invitationLink}
          inputProps={{ readOnly: true }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Share color="primary" />
              </InputAdornment>
            ),
          }}
        />
        <Typography key={1}>{t(`members.singleUseLinkText`)}</Typography>
      </DialogContent>
      <DialogActions style={{ padding: "0 24px" }}>
        <Button
          key={0}
          variant="text"
          onClick={() => {
            void navigator.clipboard.writeText(
              `${invitationLink}&clinic=${groupId}`,
            );
          }}
        >
          {t("members.Copy to clipboard")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalNewMember;
